var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoexport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1501_13045",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1501_13045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0248 15.375C11.5415 15.375 11.1331 15.2084 10.7998 14.875C10.4665 14.5417 10.2998 14.1417 10.2998 13.675V7.77502L8.9998 9.07502C8.68314 9.39169 8.2958 9.55402 7.8378 9.56202C7.37914 9.57069 6.98314 9.40836 6.64981 9.07502C6.31647 8.74169 6.14981 8.34169 6.14981 7.87502C6.14981 7.40836 6.31647 7.00836 6.64981 6.67502L10.8248 2.50002C10.9915 2.35002 11.1748 2.23336 11.3748 2.15002C11.5748 2.06669 11.7831 2.02502 11.9998 2.02502C12.2165 2.02502 12.4291 2.06669 12.6378 2.15002C12.8458 2.23336 13.0331 2.35002 13.1998 2.50002L17.3748 6.70002C17.7081 7.01669 17.8748 7.40836 17.8748 7.87502C17.8748 8.34169 17.7081 8.74169 17.3748 9.07502C17.0581 9.39169 16.6665 9.55002 16.1998 9.55002C15.7331 9.55002 15.3331 9.38336 14.9998 9.05002L13.6998 7.77502V13.675C13.6998 14.1417 13.5375 14.5417 13.2128 14.875C12.8875 15.2084 12.4915 15.375 12.0248 15.375ZM5.4498 21.9C4.51647 21.9 3.71647 21.571 3.0498 20.913C2.38314 20.2544 2.0498 19.45 2.0498 18.5V15.65C2.0498 15.1834 2.21647 14.7834 2.5498 14.45C2.88314 14.1167 3.28314 13.95 3.7498 13.95C4.23314 13.95 4.63747 14.1167 4.9628 14.45C5.28747 14.7834 5.4498 15.1834 5.4498 15.65V18.5H18.4998V15.65C18.4998 15.1834 18.6625 14.7834 18.9878 14.45C19.3125 14.1167 19.7165 13.95 20.1998 13.95C20.6665 13.95 21.0665 14.1167 21.3998 14.45C21.7331 14.7834 21.8998 15.1834 21.8998 15.65V18.5C21.8998 19.45 21.5665 20.2544 20.8998 20.913C20.2331 21.571 19.4331 21.9 18.4998 21.9H5.4498Z",
    fill: "url(#paint0_linear_1501_13045)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1501_13045",
    x1: 2.85453,
    y1: 2.02503,
    x2: 26.3412,
    y2: 3.49915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5334"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoexport);
export default __webpack_public_path__ + "static/media/Iconoexport.34fcbe7086c073255637b10a4940bc56.svg";
export { ForwardRef as ReactComponent };